<script setup lang="ts">
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'

import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'

import { AppSelectSearchable } from '@shared/ui/selects'
import { AppTooltip } from '@shared/ui/tooltips'
import { LinkTextPrimary } from '@shared/ui/links'
import { AppIcon } from '@shared/ui/icons'

import { useLessonTutorSelect } from '../../model/lessons/lesson-tutor-select.hook'

defineOptions({
  name: 'LessonTutorSelect',
})

const props = withDefaults(defineProps<{
  options: AppSelectOption<number>[]
  /** 'YYYY-MM-DD' of the lesson. */
  date: string
  label?: string
  loading?: boolean
  disabled?: boolean
}>(), {
  label: 'Tutor',
  loading: false,
  disabled: false,
})

const model = defineModel<number | null>({ default: null })

const {
  refTutorId,
  refOptions,
  refScheduleUrl,
  refIsScheduleDisabled,
} = useLessonTutorSelect({
  tutorId: model,
  refOptions: computed(() => props.options),
  refDate: computed(() => props.date),
  refIsLoading: computed(() => props.loading),
})
</script>

<template>
  <div class="lesson-tutor-select">
    <AppSelectSearchable
      v-model="refTutorId"
      :options="refOptions"
      :loading="loading"
      :disabled="disabled"
      :label="label"
      placeholder="-- Not selected --"
      clearable
    />
    <AppTooltip
      text="No Tutor"
      mode="disabled"
      placement="bottom"
    >
      <LinkTextPrimary
        :href="refScheduleUrl"
        :disabled="refIsScheduleDisabled"
        target="_blank"
      >
        Tutor Calendar
        <template #iconRight>
          <AppIcon :icon="faArrowUpRight" />
        </template>
      </LinkTextPrimary>
    </AppTooltip>
  </div>
</template>

<style scoped lang="scss" src="./LessonTutorSelect.scss" />
